import { useEffect, useState } from 'react';
import { CustomerInfo } from 'react-native-purchases';

import { importPurchases } from '%services/payment';
import { Env } from '@env';
import { useLoggedUser } from '%context/LoggedUser';

export const useSubscriptionStatus = () => {
	const { uuid } = useLoggedUser();
	const [subscriptionStatus, setSubscriptionStatus] = useState<SubscriptionStatus>('loading');

	async function fetchData(newPurchaserInfo?: CustomerInfo) {
		if (!Env.ENABLE_SUBSCRIPTIONS) {
			return setSubscriptionStatus('feature_disabled');
		}
		try {
			const Purchases = await importPurchases();
			if (!Purchases) {
				setSubscriptionStatus('error');

				return;
			}

			const purchaserInfo = newPurchaserInfo || (await Purchases.getCustomerInfo());
			const isSubscribed = !!Object.entries(purchaserInfo.entitlements.active).length;

			setSubscriptionStatus(isSubscribed ? 'active' : 'inactive');
		} catch (error) {
			console.error(error);
			setSubscriptionStatus('error');
		}
	}

	useEffect(() => {
		void fetchData();
	}, [uuid]);

	useEffect(() => {
		if (!Env.ENABLE_SUBSCRIPTIONS) {
			return;
		}

		const setupListener = async () => {
			const Purchases = await importPurchases();

			if (!Purchases) {
				return;
			}

			void Purchases.addCustomerInfoUpdateListener(fetchData);

			return () => Purchases.removeCustomerInfoUpdateListener(fetchData);
		};

		const cleanUp = setupListener();

		return void cleanUp;
	}, []);

	return {
		status: subscriptionStatus,
		type: (subscriptionStatus === 'active' ? 'premium' : 'freemium') as AccountType,
	};
};

type SubscriptionStatus = 'active' | 'inactive' | 'loading' | 'error' | 'feature_disabled';
type AccountType = 'freemium' | 'premium' | 'business';
